/** @jsx jsx */
// import { jsx, ThemeProvider } from "theme-ui";
import { jsx } from "theme-ui";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { DefaultButton } from "office-ui-fabric-react";
import { selectorSrcmProfile } from "../state/selectors";

const SignInButton = ({ btnText, btnStyle = {} }) => {
  const srcmProfile = useSelector(selectorSrcmProfile);
  const keycloakLogin = () => {
    const path =
      typeof window !== "undefined"
        ? `${window.location.pathname}${
            window.location.search ? `?${window.location.search}` : ""
          }`
        : "";
    localStorage.setItem("LandingPage", path);
    const auth = localStorage.getItem("pstate")
      ? JSON.parse(localStorage.getItem("pstate") || "")
      : "";
    if (auth?.user?.id) {
      window.location.href = `${window.location.origin}/hfnauth/authorization`;
      return false;
    }
    localStorage.clear();
    localStorage.setItem("LandingPage", path);
    return true;
  };

  if (!srcmProfile) {
    return (
      <DefaultButton
        sx={btnStyle}
        onClick={async () => {
          if (await keycloakLogin())
            document.querySelector("hfn-auth")?.triggerAuth();
        }}
        text={btnText}
      />
    );
  }
  return null;
};

SignInButton.propTypes = {
  btnText: PropTypes.string,
  btnStyle: PropTypes.shape({}),
};

SignInButton.defaultProps = {
  btnText: "Sign In",
  btnStyle: {},
};

export default SignInButton;
